/* eslint-disable */
import { $http } from '@/plugins/axios';
import { AxiosResponse } from 'axios';

export type TutorialNamespace = 'staff' | 'org_admin';

export const tutorialService = {
	list: (params?: {
		platform?: string;
		namespace?: TutorialNamespace;
	}): Promise<AxiosResponse> => {
		return $http.get(`v1/staff/tutorials`, {
			params: { platform: params?.platform || 'web' },
		});
	},

	markDone: (
		taskId: string | number,
		namespace?: TutorialNamespace
	): Promise<AxiosResponse> => {
		return $http.post(`v1/staff/tutorial_tasks/${taskId}/mark_done`);
	},
};
